module.exports = __webpack_public_path__ + "static/media/21-image.30199f56.svg";